module.exports = __webpack_public_path__ + "img/zhlogo.36e33ee4.png";